import {
  indexInfo,
  indexArticles,
  indexStaff,
} from '@/api/index'
import user from './user'

import { getFirstImageUrlFromRichText, getFirstDescFromRichText, formateDate } from '@/utils/tools';

export default Object.assign({
  async indexInfo({ commit }, data) {
    const res = await indexInfo(data);
    if (res.code === 200) {
      commit('SET_INDEX_INFO', res.data);
    }
  },
  async indexArticles({ }, data) {
    const res = await indexArticles(data);
    if (res.code === 200) {
      for (const item of res.data.rows) {
        // item._preview_img = getFirstImageUrlFromRichText(item.content, 'img');
        item._preview_img = item.coverUrl || getFirstImageUrlFromRichText(item.content, 'img');
        if (item.tag == 'mingjiajiangtan') {
          item._preview_video = getFirstImageUrlFromRichText(item.content, 'iframe');
          if (!item._preview_video) {
            item._preview_video = getFirstImageUrlFromRichText(item.content, 'video');
          }
        }

        item._desc = getFirstDescFromRichText(item.content);
        // item._create_time = formateDate(new Date(item.createTime));
        // item._create_date = item._create_time.slice(0,10);
        item._create_time = item.articleTime ? formateDate(new Date(item.articleTime)) : '';
        item._create_date = item._create_time.slice(0,10);
      }
      // res.data.rows = res.data.rows.concat(res.data.rows)
      // res.data.rows = res.data.rows.concat(res.data.rows)
      // res.data.total = 100
    }
    return res;
  },
  async indexStaff({ }, data) {
    const res = await indexStaff(data);
    // if (res.code === 200) {
      // for (const item of res.data.rows) {
      //   item._preview_img = getFirstImageUrlFromRichText(item.content, 'img');
      //   item._preview_video = getFirstImageUrlFromRichText(item.content, 'iframe');
      //   item._create_time = formateDate(new Date(item.createTime));
      //   item._create_date = item._create_time.slice(0,10);
      // }
      // res.data.rows = res.data.rows.concat(res.data.rows)
      // res.data.rows = res.data.rows.concat(res.data.rows)
      // res.data.total = 100
    // }
    return res;
  },
},
  user,
)
